<div class="flex h-full flex-col items-stretch justify-start">
    <header class="flex justify-between items-center h-[96px] pl-4 bg-[rgb(72,193,172)]">
        <h1 class="text-md sm:text-[32px] font-bold text-black">{{title()}} Demographic Form</h1>
        <div class="flex items-center">
            <div class="max-sm:hidden flex flex-row align-center gap-[5px]">
                @if (userSvc.User == null) {
                    <button mat-raised-button [routerLink]="['/login']">Admin Login</button>
                }
                @else {
                    <button mat-icon-button (click)="debugClick()"><mat-icon>info_outline</mat-icon></button>
                    <div class="text-white">
                        <div>
                            {{userSvc.User.FirstName}}
                            {{userSvc.User.LastName}}
                        </div>
                        <div>{{userSvc.User.RoleName}}</div>
                        @if (userSvc.User.Impersonation === true) {
                            <div class="text-xs">Impersonated</div>
                        }
                    </div>
                    
                    <button mat-mini-fab (click)="logout()" [matTooltip]="'Logout'">
                        <mat-icon>logout</mat-icon>
                    </button>
                }
                <button
                    type="button"
                    mat-mini-fab
                    [matTooltip]="themeMode() === 'dark' ? 'Use Light Mode' : 'Use Dark Mode'"
                    (click)="toggleTheme()"
                >
                    <mat-icon>{{ themeMode() === 'dark' ? 'dark_mode' : 'light_mode' }}</mat-icon>
                </button>
            </div>
            <a href="https://polkschoolsfl.com" title="Go to Polk County Public Schools homepage">
                <img src="/images/PCPS_White.svg" class="h-[90px] sm:h-[128px]" />
            </a>
        </div>
        <!-- <h4 class="text-md font-bold text-black block sm:hidden self-start">Contracted Staff Demographic Form</h4> -->
    </header>
    <section class="grow">
        <router-outlet></router-outlet>
    </section>
</div>
